import { User } from "oidc-client";
import { ajax, AjaxResponse, AjaxError } from "rxjs/ajax";
import { EMPTY, Observable } from "rxjs";
import { IAdministrationPayload, IAppInfoItem, ICachingKey, IInvalidAuditor } from "../../DataClasses/AdministrationData";
import AjaxHelper from "./AjaxHelper";
import { IVendorMeasure, IVendorSubOrgMapping } from "../../DataClasses/VendorMeasure";
import { ISubOrgVendor } from "../../DataClasses/SubOrgVendor";
import { IHistoricalFile } from "../../DataClasses/HistoricalFile"; 
import { retry, catchError, timeout } from 'rxjs/operators';
import { ITestOrgConfig } from "../../DataClasses/TestOrgConfig";
import { IOrganization, IOrganizationContact} from "../../DataClasses/OrganizationData";

class AdministrationService {
    public static GetAdminModel(user: User): Observable<IAdministrationPayload> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetAdminModel',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static ReprocessCahpsFile$(user: User, fileName: string, groupId: any): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/ReprocessCahpsFile?fileName=' + fileName + '&groupId=' + groupId,
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static SetAllowedStatus$(user: User, key: string, status: string): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/SetAllowedStatus?key=' + key + '&status=' + status,
            {
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static UpdateAllSubmissionStatuses(user: User): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/UpdateAllSubmissionStatuses',
            {
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static LoadNewEisSubmissions(user: User): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/LoadNewEisSubmissions',
            {
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static ClearAllLicenseAgreements$(user: User): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/ClearAllLicenseAgreements',
            {
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static SetMaintenanceMode(user: User, enable: boolean): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/SetMaintenanceMode?enable=' + enable,
            {
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static SetOffseasonMode(user: User, enable: boolean): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/SetOffseasonMode?enable=' + enable,
            {
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static SetLicenseAgreementText(user: User, text: string): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/SetLicenseAgreementText',
            {
                text: text
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }


    public static HasSignedLegalAgreement(user: User): Observable<boolean> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/HasSignedLegalAgreement',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static AddLicenseAgreementForUser(user: User): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/AddLicenseAgreementForUser',
            {
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static NeedsSignerTitle(user: User): Observable<boolean> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/NeedsSignerTitle',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static GetAllAuditors$(user: User): Observable<string[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetAllAuditors',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static GetInvalidAuditors$(user: User): Observable<IInvalidAuditor[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetInvalidAuditors',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static DoesAuditorExist$(user: User, userEmail: string): Observable<boolean> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/DoesAuditorExist?auditorEmail=' + userEmail,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static AddAuditor(user: User, userEmail: string): Observable<AjaxResponse<any> | AjaxError> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/AddAuditor?auditorEmail=' + userEmail,
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static DeleteAuditor(user: User, userEmail: string): Observable<AjaxResponse<any> | AjaxError> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/DeleteAuditor?auditorEmail=' + userEmail,
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetAppInfo$(user: User): Observable<IAppInfoItem[]>{
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetAppInfo',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetMetadataCacheList$(user: User): Observable<ICachingKey[]>{
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetMetadataCacheList',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetAllOrganizations$(user: User): Observable<IOrganization[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetAllOrganizations',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetAllOrganizationsWithContact$(user: User): Observable<IOrganizationContact[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetAllOrganizationsWithContact',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static UpdateOrganization$(user: User, orgId: number, orgName: string): Observable<AjaxResponse<any> | AjaxError> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/UpdateOrganization',
            {
                'EisOrgId': orgId,
                'OrgName': orgName,
                'Inactive': false
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    } 
    public static UpdateOrgContact$(user: User, orgId: number, firstName: string, lastName: string): Observable<AjaxResponse<any> | AjaxError> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/UpdateOrganizationContact',
            {
                'EisOrgId': orgId,
                'ContactFirstName': firstName,
                'ContactLastName': lastName
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    } 
    public static GetConfigKey$(user: User, key: string): Observable<string> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetConfigKey?key=' + key,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetVendorMeasures$(user: User, productYear: number): Observable<IVendorMeasure[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetVendorMeasures?productYear=' + productYear,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetSoftwareVendorList$(user: User, productYear: number): Observable<IVendorSubOrgMapping[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetValidSoftwareVendorList?productYear=' + productYear,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetExtractedFolderInfo$(user: User): Observable<string> { 
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetExtractedFolderInfo',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static RunSystemConsistencyCheck$(user: User): Observable<{ type: string, messages: string[] }[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/RunSystemConsistencyCheck',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetHedisSubmissionSummaries$(user: User, includeTestOrgs: boolean): Observable<{type: string, count: number}[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetHedisSubmissionSummaries?includeTestOrgs=' + includeTestOrgs,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static GetConfigUserMsgOnLoginModel$(): Observable<{ enable: boolean, message: string }> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetConfigUserMsgOnLoginModel',
        )
    }

    public static GetHelpDocs$(): Observable<{ key: string, title: string, description: string, href: string }[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetHelpDocs'
        )
    }

    public static AddHelpDoc$(user: User, model: { key: string, title: string, description: string, href: string }) {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/AddHelpDoc',
            model,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static RemoveHelpDoc$(user: User, key: string) {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/RemoveHelpDoc?key=' + encodeURIComponent(key),
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static ClearVendorMeasureCache$(user: User){
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/ClearVendorMeasureCache',
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static DownloadCache$(key: string, user: User): Observable<string> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/DownloadCache?key=' + key,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static ClearCaches$(cacheKeysCsv: string, user: User){
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/ClearCaches?cacheKeysCsv=' + cacheKeysCsv,
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static GetSubOrgVendorMap$(user: User): Observable<ISubOrgVendor[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetSubOrgVendorMap',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static GetTestOrgsConfig$(user: User, measurementYear: number): Observable<ITestOrgConfig[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/GetTestOrgsConfig?measurementYear=' + measurementYear,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static AddTestOrgsConfig$(user: User, orgIdsStr: string) {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/AddTestOrgsConfig?orgIdsStr=' + orgIdsStr,
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    public static DeleteTestOrgConfig$(user: User, orgId: number) {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/DeleteTestOrgConfig?orgId=' + orgId,
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static AdminGetHistoricalFileList$(user: User, mys: string, subIds: string): Observable<IHistoricalFile[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/AdminGetHistoricalFiles?myStr=' + mys + '&subIdStr=' + subIds,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
    
    public static GetHistoricalFileDownloadUrl$(user: User, measurementYear: number, submissionId: number, fileTypeId: number): Observable<string> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/AdminGetHistoricalDownloadLink?measurementYear=' + measurementYear + '&submissionId=' + submissionId + '&fileTypeId=' + fileTypeId,
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static GetHistoricalFilesZip(user: User, historicalFiles: IHistoricalFile[]) {
        return ajax({
            url: process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/AdminDownloadHistoricalFiles',
            method: 'POST',
            body: {historicalFiles},
            headers: AjaxHelper.CreateHttpHeaders(user),
            responseType: 'blob',
        }).pipe(
            timeout(30 * 60 * 1000),
            retry(parseInt(process.env.REACT_APP_GENERAL_RETRYLOGICCOUNT)),
            catchError(() => {return EMPTY})
        );
    }

    public static UploadHelpDocFile$(user: User, file: File) {
        const formData = new FormData();
        formData.append("file", file, file.name);
        return ajax({
            url: process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Administration/UploadHelpDocFile',
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': 'Bearer ' + user.access_token
            },
            responseType: 'json',
        });
    }
}

export default AdministrationService;
